exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sign-up-page .signon{margin-bottom:200px}.sign-up-page .modal-dialog.signon-modal{width:378px}.sign-up-page .modal-dialog.signon-modal .signon-header{margin-bottom:20px}.sign-up-page .modal-dialog.signon-modal .mobile-app-links i{margin-right:16px}.sign-up-page .modal-dialog.signon-modal .terms-and-service{border-top:none}.third-party-wrapper{margin-bottom:15px}.sign-up-page.signon form{width:100%}.sign-up-page.signon form .company-name-signon{color:#fff;font-family:Poppins,sans-serif;font-size:14px;font-weight:700;line-height:40px;height:40px;width:100%;border-radius:6px;border:none;background-color:#62c046;text-align:center;margin-top:16px;cursor:pointer}.sign-up-page.signon .sms-code-container input{width:32px;border:none;border-bottom:2px solid #868c8e;background:none;box-shadow:none;color:#62c046;font-family:Poppins,sans-serif;font-size:24px;font-weight:700;letter-spacing:0;line-height:24px;text-align:center;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/app/components/signon/signon.css
// module id = 285
// module chunks = 0